var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgScanCheckIcon = function SvgScanCheckIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.76227,
    cy: 8.41101,
    r: 8,
    fill: "#FFCB04"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6948 5.85255C12.9741 6.11435 12.9882 6.55296 12.7264 6.83221L8.01025 11.8628C7.87639 12.0056 7.68841 12.0851 7.49272 12.0818C7.29703 12.0784 7.11189 11.9925 6.98301 11.8452L4.78218 9.32989C4.53012 9.04182 4.55931 8.60396 4.84739 8.3519C5.13546 8.09984 5.57333 8.12904 5.82538 8.41711L7.52234 10.3565L11.7152 5.88416C11.977 5.60491 12.4156 5.59076 12.6948 5.85255Z",
    fill: "#404041"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgScanCheckIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjguNzYyMjciIGN5PSI4LjQxMTAxIiByPSI4IiBmaWxsPSIjRkZDQjA0Ii8+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyLjY5NDggNS44NTI1NUMxMi45NzQxIDYuMTE0MzUgMTIuOTg4MiA2LjU1Mjk2IDEyLjcyNjQgNi44MzIyMUw4LjAxMDI1IDExLjg2MjhDNy44NzYzOSAxMi4wMDU2IDcuNjg4NDEgMTIuMDg1MSA3LjQ5MjcyIDEyLjA4MThDNy4yOTcwMyAxMi4wNzg0IDcuMTExODkgMTEuOTkyNSA2Ljk4MzAxIDExLjg0NTJMNC43ODIxOCA5LjMyOTg5QzQuNTMwMTIgOS4wNDE4MiA0LjU1OTMxIDguNjAzOTYgNC44NDczOSA4LjM1MTlDNS4xMzU0NiA4LjA5OTg0IDUuNTczMzMgOC4xMjkwNCA1LjgyNTM4IDguNDE3MTFMNy41MjIzNCAxMC4zNTY1TDExLjcxNTIgNS44ODQxNkMxMS45NzcgNS42MDQ5MSAxMi40MTU2IDUuNTkwNzYgMTIuNjk0OCA1Ljg1MjU1WiIgZmlsbD0iIzQwNDA0MSIvPgo8L3N2Zz4K";